module.exports = __webpack_public_path__ + "img/dec16-24-cal.5661c742.svg";